import { __assign, __extends } from "tslib";
import React from 'react';
import classnames from 'classnames';
import ddt from '@wix/da-ddt';
import { SessionContext } from '@wix/da-react-context/pkg/SessionContext';
import s from './ErrorBoundary.scss';
var filteredErrors = [
    { filter: /Failed to execute 'removeChild'/i },
    { filter: /Failed to execute 'insertBefore'/i },
    { filter: /The object can not be found here/i },
    { filter: /IntersectionObserver/i },
    { filter: /ResizeObserver/i },
    { filter: /Loading chunk/i },
    { filter: /Loading CSS chunk/i },
    { filter: /access dead object/i },
    { filter: /Permission denied to access object/i },
    { filter: /invariant=306/i, component: ['ChatInit'] },
    { filter: /Intl is not defined/i },
    { filter: /Object\.entries is not a function/i },
    { filter: /Object\.values is not a function/i },
    { filter: /not a child of this node/i }, // Adblocker
];
var stackFilters = [/user-script/];
var ErrorBoundary = /** @class */ (function (_super) {
    __extends(ErrorBoundary, _super);
    function ErrorBoundary() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ErrorBoundary.getDerivedStateFromError = function () {
        return { isError: true };
    };
    ErrorBoundary.prototype.componentDidCatch = function (error, errorInfo) {
        var _a;
        if (process.env.NODE_ENV === 'development' &&
            errorInfo &&
            errorInfo.componentStack) {
            // eslint-disable-next-line no-console
            console.error(errorInfo.componentStack); // tslint:disable-line
        }
        var shouldLog = true;
        for (var _i = 0, filteredErrors_1 = filteredErrors; _i < filteredErrors_1.length; _i++) {
            var fe = filteredErrors_1[_i];
            if (fe.filter.test(error && error.message)) {
                if (Array.isArray(fe.component) &&
                    !((_a = fe.component) === null || _a === void 0 ? void 0 : _a.includes(this.props.debugComponent))) {
                    continue; // allows filtering for specific components
                }
                shouldLog = false;
                break;
            }
        }
        for (var _b = 0, stackFilters_1 = stackFilters; _b < stackFilters_1.length; _b++) {
            var sf = stackFilters_1[_b];
            if (sf.test(error && error.stack)) {
                shouldLog = false;
                if (/user-script/.test(error && error.stack)) {
                    alert('Your user script crashed, please reload the page.');
                }
            }
        }
        if (!shouldLog) {
            return;
        }
        ddt.alert('fatal', "Error Boundary Caught: ".concat((error && error.message) || 'unknown'), ['fatal', this.props.debugComponent], {
            stacktrace: error && error.stack,
            component: this.props.debugComponent,
            session: this.props.sessionContext,
        });
        if (process.env.NODE_ENV === 'test') {
            throw error;
        }
    };
    ErrorBoundary.prototype.render = function () {
        if (this.state && this.state.isError) {
            if (this.props.hideOnFail) {
                return null;
            }
            return (React.createElement("div", { className: classnames(s['error'], this.props.className), style: this.props.style },
                this.props.humanError && React.createElement("p", null, this.props.humanError),
                !this.props.humanError && (React.createElement(React.Fragment, null,
                    React.createElement("p", { className: s['error-code'] }, "E_GURU_MEDITATION"),
                    React.createElement("h3", { className: s['error-heading'] }, "Something's gone wrong on our end"),
                    React.createElement("p", null,
                        "We're having a technical issue. Try reloading the page.",
                        React.createElement("br", null),
                        "If this keeps happening, please contact Customer Support.")))));
        }
        return this.props.children;
    };
    return ErrorBoundary;
}(React.Component));
var withContext = function (props) { return (React.createElement(SessionContext.Consumer, null, function (contextProps) { return React.createElement(ErrorBoundary, __assign({}, props, { sessionContext: contextProps })); })); };
withContext.displayName = 'ErrorBoundary';
export default withContext;
//# sourceMappingURL=ErrorBoundary.js.map